import React, { createContext, useEffect } from 'react';

import { useShow } from '../hooks';

export const AssetContext = createContext(null);

export function AssetProvider({ assetId, children }) {
  const { entity: asset, handleShow, loading } = useShow('assets');

  useEffect(() => {
    if (assetId) {
      handleShow(assetId);
    }
  }, [ assetId, handleShow ]);

  if (loading && assetId) {
    return <div>Loading Asset {assetId}...</div>;
  }

  return (
    <AssetContext.Provider value={{ asset }}>
      {children}
    </AssetContext.Provider>
  );
}